// 标记的符号
export const markString = ['-||', '||-'];
// 标记的符号
export const interpolationMark = ['%$$', '$$%'];



// WEBPACK FOOTER //
// ./src/service/common.ts